// extracted by extract-css-chunks-webpack-plugin
module.exports = {"brandsTitle":"brandsTitle-1C9EsBtu","titleWrapper":"titleWrapper-1Oq9T__1","title_logo":"title_logo-3Xq6Gqwm","title":"title-29mu4cQR","linkList":"linkList-3GNlhlP7"};